import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user: JSON.parse(localStorage.getItem('user')) || {
      id: '',
      username: '',
      avatar: '',
      phone: ''
    },
    info: JSON.parse(sessionStorage.getItem('info')) || {},
    currentDevice: null,
    devices: [],
    backMachineId: ''
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.user = user
      sessionStorage.setItem('info', JSON.stringify(user))
    },
    CLEAR_AUTH(state) {
      state.token = ''
      state.user = {
        id: '',
        username: '',
        avatar: '',
        phone: ''
      }
      localStorage.removeItem('token')
      sessionStorage.removeItem('info')
    },
    SET_CURRENT_DEVICE(state, device) {
      state.currentDevice = device
      localStorage.setItem('currentDevice', JSON.stringify(device))
    },
    SET_DEVICES(state, devices) {
      state.devices = devices
    },
    SET_MACHINE_ID(state, machineId) {
      state.backMachineId = machineId
    }
  },
  actions: {
    setBackMachineId({ commit }, machineId) {
      commit('SET_MACHINE_ID', machineId)
    },
    login({ commit }, { token, user }) {
      console.log('token',token);
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
      router.push('/home')
    },
    register({ commit }, { token, user }) {
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    },
    selectDevice({ commit }, device) {
      commit('SET_CURRENT_DEVICE', device)
    },
    updateDevices({ commit }, devices) {
      commit('SET_DEVICES', devices)
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    currentUser: state => state.user,
    currentDevice: state => state.currentDevice,
    allDevices: state => state.devices,
    backMachineId: state => state.backMachineId
  }
}) 